import posthog from 'posthog-js'
import SharedTransferTrackingLink from 'components/transferTrackingLink'

/**
 * «پیگیری واریز وام» under «درخواست پذیرفته شد».
 *
 * Owner's ask (2026-09-17): when the loan went out from موجودی نزد همیان, the
 * acceptance line should lead straight to where the money is. The link itself
 * — its look, and the /t/ page's stage wording — is the shared one the fund's
 * transaction sheet also uses; this file only adds this page's title and event.
 */
export default function TransferTrackingLink({
    transfer,
    fundId,
    demandId,
    viewer,
}: {
    transfer: ILoanDemandTransfer
    fundId: string | null
    demandId: string | undefined
    viewer: 'manager' | 'requester'
}) {
    return (
        <SharedTransferTrackingLink
            transfer={transfer}
            title="پیگیری واریز وام"
            className="mt-2"
            onOpen={() =>
                posthog.capture('loan_demand_transfer_tracking_opened', {
                    fund_id: fundId,
                    demand_id: demandId,
                    stage: transfer.stage,
                    viewer,
                })
            }
        />
    )
}
